import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";
import { DELETE, GET, POST, PUT } from "../../../helpers/apiHelper";
import {
  SuccessCreate,
  SuccessDelete,
  SuccessUpdate,
} from "../../../helpers/toastHelper";
import * as action from "./action";

export const getListState = (state) => state.cityApp.list;

const loadMasterCityListAsync = async (query) => GET(`/city?${query}`);
const loadMasterProvinceListAsync = async () => GET(`/province`);
const addMasterCityAsync = async (item) => POST(`/city`, item);
const editMasterCityAsync = async (id, item) =>
  PUT(`/city/${id}`, item);
const deleteMasterCityAsync = async (id) => DELETE(`/city/${id}`);

function* loadMasterCityList({ payload }) {
  try {
    const list = yield select(getListState);

    let param = [
      {
        name: "page",
        value: payload.selectedPage,
      },
      {
        name: "orderBy",
        value: list.orderBy,
      },
      {
        name: "sortedBy",
        value: list.sortedBy,
      },
      {
        name: "limit",
        value: payload.limit,
      },
    ];

    if (list.filter || "") {
      param = [
        ...param,
        ...[
          {
            name: "search",
            value: list.filter,
          },
          {
            name: "searchFields",
            value: list.filterFields,
          },
          {
            name: "searchJoin",
            value: list.searchJoin,
          },
        ],
      ];
    }
    const response = yield call(
      loadMasterCityListAsync,
      param.map((t) => `${t.name}=${t.value}`).join("&")
    );
    yield put(action.loadMasterCityListSuccess(response));
  } catch (error) {
    yield put(action.loadMasterCityListError(error));
  }
}

function* loadMasterProvinceList() {
  try {
    const response = yield call(loadMasterProvinceListAsync);
    yield put(action.getProvinceListSuccess(response));
  } catch (error) {
    yield put(action.getProvinceListError(error));
  }
}

function* saveAddeditMasterCity({ payload }) {
  let response = null;
  try {
    if (payload.item) {
      if (payload.mode === "edit") {
        response = yield call(
          editMasterCityAsync,
          payload.item.id,
          payload.item
        );
      } else if (payload.mode === "add") {
        response = yield call(addMasterCityAsync, payload.item);
      } else {
        throw new Error("invalid mode");
      }
      yield put(action.saveAddeditMasterCitySuccess(response));
      yield put(action.loadMasterCityList());
      if (payload.mode === "add") {
        SuccessCreate();
      } else if (payload.mode === "edit") {
        SuccessUpdate();
      }
    } else {
      throw new Error("invalid save item, cannot be null");
    }
  } catch (error) {
    yield put(action.saveAddeditMasterCityError(error));
  }
}

function* deleteMasterCity({ payload }) {
  try {
    if (payload && payload.confirmed) {
      if (payload.item) {
        yield call(deleteMasterCityAsync, payload.item.id);
        yield put(action.deleteMasterCitySuccess());
        yield put(action.loadMasterCityList());
        SuccessDelete();
      } else {
        throw new Error("invalid delete item, cannot be null");
      }
    }
  } catch (error) {
    yield put(action.deleteMasterCityError(error));
  }
}

export function* watchLoadMasterCityList() {
  yield takeEvery(action.LOAD_MASTER_CITY_LIST, loadMasterCityList);
}

export function* watchLoadMasterProvinceList() {
  yield takeEvery(action.ADDEDIT_MASTER_CITY, loadMasterProvinceList);
}

export function* watchSaveAddeditMasterCity() {
  yield takeEvery(action.SAVE_ADDEDIT_MASTER_CITY, saveAddeditMasterCity);
}

export function* watchDeleteMasterCity() {
  yield takeEvery(action.DELETE_MASTER_CITY, deleteMasterCity);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoadMasterCityList),
    fork(watchLoadMasterProvinceList),
    fork(watchSaveAddeditMasterCity),
    fork(watchDeleteMasterCity),
  ]);
}
